import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { colors, types } from "../../../../libs";

export const InviteModal = styled(Modal)`
  .modal-dialog {
    max-width: 580px;
  }
  .modal-content {
    background: transparent;
    border: 0;
  }
`;
export const ModalWrapper = styled.div`
  width: 100%;
  padding: 24px;
  background: ${colors.background.lightBlack};
  border-radius: 8px;
`;
export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 22px;
`;
export const ModalTitle = styled.div`
  ${types.body.secondaryTitle};
  color: ${colors.text.white};
  font-weight: bold;
`;
export const Subtitle = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 5px;
`;
export const CloseButton = styled.button`
  border: 0;
  background: transparent;
  color: ${colors.text.gray};
  display: flex;
  padding: 4px;
  &:hover {
    color: ${colors.text.white};
  }
`;
export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const Field = styled.div`
  width: 100%;
  min-width: 0;
`;
export const FieldLabel = styled.div`
  ${types.body.normal};
  color: ${colors.text.disabled};
  margin: 0 0 6px 5px;
`;
export const MissingDestination = styled.div`
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 15px;
  background: ${colors.background.formField};
  color: ${colors.text.white};
`;
export const InlineAction = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 0;
  background: transparent;
  color: ${colors.text.green};
  white-space: nowrap;
`;
export const AddAnother = styled.button`
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: ${colors.text.green};
  padding: 0;
`;
export const UrlSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 5px;
`;
export const UrlActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`;
export const TextButton = styled.button`
  border: 0;
  background: transparent;
  color: ${colors.text.gray};
  padding: 8px 4px;
`;
export const SmallButton = styled.div`
  width: 120px;
`;
export const Footer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;
export const ButtonSlot = styled.div`
  flex: 1;
`;
